<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="用户"
      :is-dialog-query="isDialogQuery"
      :show-summary="summaryShow"
      :expand-all-row="true"
      :page="true"
      :show-checkbox="false"
      :show-query="true"
      :query-params="params"
      :get-data-func="getDataFunc"     
      @closeDialog="closed"
      :summary-method="summaryFunc"
      isShowText
      :showTextArr="showTextArr"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="success" @click="onPrint">打印</el-button>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/purchase/stockcount/list.json";
import tableParam from "@/data/business/purchase/stockcount/query.json";
import Bus from "@/utils/bus";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    //是否弹窗查询
    isDialogQuery: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formApi: require("@/api/sy/formSetting").default,
      tableApi: require("@/api/sy/tableSetting").default,
      queryApi: require("@/api/sy/selectSetting").default,
      api: require("@/api/pu/puDoc").default,
      
      // trendColumn: tableColumn.Data,
      // tableColumns: tableColumn.Data,
      // trendParams: tableParam.Data,
      // tableParams: tableParam.Data,
      // trendShow: true,
      showTextArr: [
        {
          type: "time",
          label: "单据时间",
          startKey: "DocDateStart",
          endKey: "DocDateEnd",
        },
        {
          type: "data",
          label: "供应商",
          key: "TradeUnitName",
        },
        {
          type: "data",
          label: "存货",
          key: "ProductName",
        },
      ],
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
      summaryShow: false,
      total: null
    };
  },

  activated() {
    if (this.$refs.list.isSetQuery === false) {
      this.getData();
    }
  },
  mounted() {
    if (!this.$permission.canPrice("/business/purchase/stockcount")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(item => item.tableName == "Amount");
      if (findIndex >= 0) list.tableList.splice(findIndex, 1);
      const findIndex0 = list.tableList.findIndex(item => item.tableName == "TaxLimit");
      if (findIndex0 >= 0) list.tableList.splice(findIndex0, 1);
      const findIndex2 = list.tableList.findIndex(item => item.tableName == "TaxAmount");
      if (findIndex2 >= 0) list.tableList.splice(findIndex2, 1);
    } 
    Bus.$on("closeTag", (route) => {
      console.log("route.fullPath 进货单统计表", route.fullPath);
      console.log("this.$route.fullPath 进货单统计表", this.$route.fullPath);

      if (route.fullPath === "/business/purchase/stockcount") {
        this.$refs.list.data = [];
        this.$refs.list.isSetQuery = false;
      }
    });
  },

  methods: {
    closed(isSetQuery) {
      if (!isSetQuery) {
        this.closeSelectedTag(this.$route);
      }
    },
    isActive(route) {
      return route.path === this.$route.path;
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0];
      if (latestView) {
        this.$router.push(latestView.fullPath);
      } else {
        // now the default is to redirect to the home page if there is no tags-view,
        // you can adjust it according to your needs.
        if (view.name === "index") {
          // to reload home page
          this.$router.replace({ path: view.fullPath });
        } else {
          this.$router.push("/");
        }
      }
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delView", view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view);
        }
      });
    },
    onPrint() {
      var list = this.$refs.list;
      var listParams = list.tempQueryParams;
      var fields = list.tableList.map((x) => x.tableName);
      var params = { ...listParams, Fields: fields.join(",") };
      var data = {
        Params: params,
        TableNames: list.tableList,
        ParamsData: list.paramsData,
      };
      sessionStorage.setItem("stockcount_print", JSON.stringify(data));

      var origin = location.origin;
      window.open(origin + "/#/business/purchase/stockcount/print");
    },
    // getDateFunc(){
    //   return new Promise(resolve=>{
    //       this.api.list({'Code':'ProcessStage'}).then(res=>{
    //         resolve({Data:res.Data,Count:res.Count,Code:res.Code})
    //       })
    //   })
    // },
    //
    getDataFunc(params) {
      console.log("getDataFunc", params);
      return new Promise((resolve, reject) => {
        this.api.getPuDocStatistics(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            console.log('进入-------');
            this.api.getPuDocStatisticsTotal(params).then(res => {
              console.log("total", res)
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["PuQuantity", "Amount",'TaxLimit','SettlementAmount','RestAmount','StockInQuantity','StockInQuantity2','InvoiceQuantity','InvoiceQuantity2','RefundQuantity','RefundQuantity2','TaxAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.statisticsExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    }
  },
};
</script>